import { MapOperation } from './map-operation';

/**
 * グーグルマップから制御が渡されるエントリーポイント
 */
window.initMap = () => {
    // PHPからのパラメーター
    const parameters = JSON.parse(document.getElementById('js-search-parameter').textContent);

    // マップ操作オブジェクトを生成
    const mapOperation = new MapOperation(parameters);
    mapOperation.initMap();

    // UIにイベントハンドラーを設定
    $(` #select-recruiting-personnel,
        #select-pay-per-hour,
        #input-working-date-from,
        #input-working-date-to,
        #select-travel-cost,
        #select-staff-parking,
        input[name="dw[]"]
    `).on('change', () => mapOperation.changeHandler());
    $('#search-button').on('click', () => mapOperation.changeHandler());
    $('#current-location-button').on('click', () => mapOperation.goToCurrentLocation());

    $('#save-condition-1').on('click', () => mapOperation.saveCondition(1));
    $('#save-condition-2').on('click', () => mapOperation.saveCondition(2));
    $('#save-condition-3').on('click', () => mapOperation.saveCondition(3));

    $('#condition-button-1').on('click', () => mapOperation.loadCondition(1));
    $('#condition-button-2').on('click', () => mapOperation.loadCondition(2));
    $('#condition-button-3').on('click', () => mapOperation.loadCondition(3));
    if ($('#condition-button-1').length > 0) {
        // ログイン中ならダイアログ表示の際に使用可能な番号を問い合わせる
        $('#load-button').on('click', () => mapOperation.inquireAvailableNumbers());
    }
};
